<div class="iban-input-container" [formGroup]="form">
  <input
    placeholder="IBAN eingeben"
    type="text"
    [name]="name"
    [formControlName]="controlName"
    [mask]="mask"
    [inputTransformFn]="inputTransformFn"
    [outputTransformFn]="outputTransformFn"
    [class.error]="errorMessage()"
  />
  @if (errorMessage(); as message) {
    <span class="error-message">{{ message }}</span>
  }
</div>
